import React, { useCallback } from "react";
import { useWorkspaceAccrualAccounts } from "@api/account.api";
import { useChartOfAccountsQuery } from "@api/accountingReports.api";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { Separator } from "@design-system/Separator/Separator";
import { BaseFilterProps } from "../../lib";
import { CoaAccountList } from "../CoaAccountFilter/CoaAccountList";
import styles from "./AccrualCoaAccountFilter.module.scss";

interface Props extends BaseFilterProps {
    hideNoAccountOption?: boolean;
}

export const AccrualCoaAccountFilter: React.FC<Props> = ({
    filters,
    onChange,
    hideNoAccountOption = false,
}) => {
    const { data: accounts } = useWorkspaceAccrualAccounts();
    const { data: chartOfAccounts } = useChartOfAccountsQuery();

    const handleToggleNoAccount = useCallback(() => {
        onChange({
            includeUnassignedAccrualAccount:
                filters.includeUnassignedAccrualAccount ? undefined : true,
        });
    }, [filters.includeUnassignedAccrualAccount, onChange]);

    return (
        <CoaAccountList
            accounts={accounts}
            groups={chartOfAccounts?.groups}
            entityIds={filters.entityIds}
            selectedIds={filters.accrualCoaAccounts}
            onSelectedIdsChange={(accrualCoaAccounts) =>
                onChange({ accrualCoaAccounts })
            }
            onClearAll={() =>
                onChange({
                    accrualCoaAccounts: undefined,
                    includeUnassignedAccrualAccount: undefined,
                })
            }
            extraSelectedCount={filters.includeUnassignedAccrualAccount ? 1 : 0}
            headerSlot={({ search }) =>
                search || hideNoAccountOption ? null : (
                    <>
                        <section className={styles.noAccountSection}>
                            <Checkbox
                                checked={
                                    !!filters.includeUnassignedAccrualAccount
                                }
                                onCheckedChange={handleToggleNoAccount}
                                className={styles.noAccountCheckbox}
                                labelPlacement="start"
                                label={
                                    <span className={styles.noAccountLabel}>
                                        No account
                                    </span>
                                }
                            />
                        </section>
                        <Separator block className={styles.divider} />
                    </>
                )
            }
        />
    );
};
